import { apiBaseAssets } from "../config/api";
import lc from "../utils/language";
export const Team = ({ data, isRtl }) => {
  return (
    <div id="team" className="text-center" >
      <div className="container" >
        <div className="col-md-12  section-title" style={{ background: 'none' }}>
          <h2 style={{ fontFamily: isRtl ? "amiriBold" : "Merriweather" }}>
            {data[lc("title", isRtl)]}
          </h2>
          <p style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: '#7FB6FF' }}>
            {data[lc("subTitle", isRtl)]}
          </p>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', justifyContent: 'center' }}>
          {data.teams.length > 0
            ? data.teams.map((d, i) => (
              <div key={d._id} className="col-md-3 col-sm-6 team">
                <div className="team-image-wrapper">
                  <div
                    style={{
                      backgroundImage: `url(${apiBaseAssets + d.background})`,

                    }}
                    className="round-image-background"
                  />

                  <div className="caption">
                    <h4
                      style={{
                        fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#fff'
                      }}
                    >
                      {d[lc("title", isRtl)]}
                    </h4>
                    <p
                      style={{
                        fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: 'rgba(242, 242, 242,0.7)'
                      }}
                    >
                      {d[lc("subTitle", isRtl)]}
                    </p>
                  </div>
                </div>
              </div>
            ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
